
import styled from "@emotion/styled";

export const CustomLoginWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout, pathname }) => {
    let LightLogoBg = ''
    try {
        LightLogoBg = require('../../../assets/img/logo.png')
    } catch (error) {
        // noop
    }


    if (!isApplyCustomLayout) return ``
    return `
        &::before {
            content: "";
            position: absolute;
            top: -36px;
            left: 0;
            right: 0;
            height: ${(APP_CONFIG.logoHeight || 34) * 1.5}px;
            background: url(${LightLogoBg}) top center no-repeat;
            background-size: ${(APP_CONFIG.logoWidth || 99) * 1.5}px ${(APP_CONFIG.logoHeight || 34) * 1.5}px;
            z-index: 1000;
        }

        .social-title-left {
            display: none !important;
        }
    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomLoginWrapper/style.jsx